import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Spin } from 'antd';
import ReduxRegistriList from 'containers/fe/ReduxRegistriList.jsx';
import ReduxCriticalList from 'containers/fe/ReduxCriticalList.jsx';
// import ReduxRegistriAlert from 'containers/fe/ReduxRegistriAlert.jsx';

class RegistriDashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      err: null,
      xhr: null,
      status: 'loading',
    };
  }

  render() {
    return (
      <div>
        <Spin
          spinning={this.props.isLoadingCritical}
          tip="Caricamento..."
        >
          <ReduxCriticalList />
          <ReduxRegistriList />
        </Spin>
      </div>
    );
  }
}

// <ReduxRegistriAlert />
RegistriDashboard.propTypes = {
  isLoadingCritical: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => ({
  isLoadingCritical: state.registriList.loadingCritical,
});

const ReduxRegistriDashboard = connect(
  mapStateToProps,
)(RegistriDashboard);

export default ReduxRegistriDashboard;
